<template>
    <div class="page-content">
        <div class="section main-section">
            <h2>Top destinations to visit</h2>
            <p>We help you plan the best getaway trip.</p>

            <form class="search">
                <input type="search" placeholder="Where do you want to go?" />
                <button type="submit" class="main-btn">Search Trips</button>
            </form>

            <div class="destination-list">
                <DestinationItem v-bind:hasOverlay="true"></DestinationItem>
                <DestinationItem
                    v-for="n in 5"
                    v-bind:key="n"
                    v-bind:hasOverlay="false"></DestinationItem>
            </div>

            <button class="main-btn">Discover More</button>
        </div>

        <div class="section featured-itineraries">
            <h2>Featured Itineraries</h2>
            <p>We keep a vitrual diary of your trips for you to share and reminisce.</p>

            <div class="itineraries-list">
                <ItineraryItem v-for="n in 6" v-bind:key="n"></ItineraryItem>
            </div>
        </div>

        <div class="section how-it-works">
            <h2>How it Works</h2>

            <div class="directions-list">
                <div class="direction-item">
                    <div class="direction__image">
                        <img src="assets/images/strategy.png" alt="Step 1 Image" />
                    </div>

                    <div class="direction__title">Step 1</div>
                    <p>Create your trip using our <span>itinerary planner</span></p>
                </div>
                <div class="direction-item">
                    <div class="direction__image">
                        <img src="assets/images/menu.png" alt="Step 2 Image" />
                    </div>

                    <div class="direction__title">Step 2</div>
                    <p><span>Save</span> it and <span>download</span> the plan to your phone</p>
                </div>
                <div class="direction-item">
                    <div class="direction__image">
                        <img src="assets/images/virtual-reality.png" alt="Step 3 Image" />
                    </div>

                    <div class="direction__title">Step 3</div>
                    <p><span>Navigate</span> through your entire trip, one place at a time</p>
                </div>
            </div>

            <button class="main-btn">Create a New Itinerary</button>
        </div>

        <div class="section logos">
            <div class="logos-list">
                <div class="logo-item">
                    <img src="assets/images/logos/logo1.png" alt="Logo Name" />
                </div>
                <div class="logo-item">
                    <img src="assets/images/logos/logo2.png" alt="Logo Name" />
                </div>
                <div class="logo-item">
                    <img src="assets/images/logos/logo3.png" alt="Logo Name" />
                </div>
                <div class="logo-item">
                    <img src="assets/images/logos/logo4.png" alt="Logo Name" />
                </div>
                <div class="logo-item">
                    <img src="assets/images/logos/logo5.png" alt="Logo Name" />
                </div>
            </div>
        </div>

        <div class="section testimonials">
            <h2>Testimonials from our users</h2>

            <div class="testimonials-list">
                <TestimonialItem v-for="n in 3" v-bind:key="n"></TestimonialItem>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'TopDestinations',
        components: {
            DestinationItem: require('./destinationItem').default,
            ItineraryItem: require('./itineraryItem').default,
            TestimonialItem: require('./testimonialItem').default
        },
        beforeCreate: function() {
            let body = document.querySelector('body')
            body.dataset.page = 'top-destinations'
        }
    }
</script>

<style scoped lang="scss">
    .section.main-section {
        margin-left: auto;
        margin-right: auto;
        max-width: 860px;
    }


    .main-section > .main-btn {
        display: block;
        margin: 41px auto 0;

        @media all and (max-width: $breakpoint) {
            margin-top: 20px;
            width: 100%;
        }
    }


    .search [type="search"],
    .search button {

        @media all and (max-width: $breakpoint) {
            margin-left: 0;
            margin-right: 0;
        }
    }


    .destination-list {

        @media all and (max-width: $breakpoint) {
            margin-top: 20px;
        }
    }
</style>
